// src/components/PsicomotricidadeInfo.tsx
import React from 'react';
import '../../styles/especialidades.css';

const NeurologistaInfo: React.FC = () => (
    <section className="about_psicomotricidade">
        <div className="teste_zoom_two">
            <div className="about_text_psicomotricidade">
                <h2 className='sub_title'><b>Aprendizados, emoções e desenvolvimento.</b></h2>
                <br/>
                <p>A Psicopedagogia é uma área interdisciplinar que atua na compreensão, prevenção e superação das dificuldades de aprendizagem. Unindo os conhecimentos da Psicologia e da Pedagogia, o psicopedagogo analisa os fatores emocionais, cognitivos, sociais e escolares que impactam o processo de ensino-aprendizagem, com o objetivo de promover o desenvolvimento pleno do indivíduo.</p>
                <br/>   
                <p>Mais do que identificar dificuldades específicas, a atuação psicopedagógica busca entender como cada pessoa aprende, respeitando seu ritmo, sua história e suas singularidades. Através de estratégias personalizadas, o trabalho do psicopedagogo favorece a autonomia, o prazer de aprender e a recuperação da autoestima acadêmica.</p>
                <br/>   
                <p><b>Quando procurar um psicopedagogo?</b></p>
                
                    <li>Crianças e adolescentes com dificuldades de aprendizagem relacionadas à leitura, escrita, raciocínio lógico, atenção ou memória;</li>
                    <li>Estudantes com baixo rendimento escolar, desmotivação ou aversão à escola;</li>
                    <li>Indivíduos com transtornos como TDAH, dislexia, discalculia ou disortografia;</li>
                    <li>Casos em que há impacto emocional associado ao desempenho escolar, como ansiedade, insegurança ou baixa autoestima;</li>
                    <li>Pais e professores que buscam orientação para melhorar o ambiente de aprendizagem e o vínculo com o educando.</li>
                
                <br/>
                <p><b>Benefícios da psicopedagogia.</b></p>
                <br />
                
                    <li>Identificar as causas das dificuldades de aprendizagem, indo além dos sintomas escolares;</li>
                    <li>Criar estratégias personalizadas que favorecem o desenvolvimento cognitivo e emocional;</li>
                    <li>Fortalecer vínculos entre família, escola e criança, promovendo um ambiente de aprendizagem mais acolhedor;</li>
                    <li>Estimular a autonomia, a autoconfiança e o prazer de aprender;</li>
                    <li>Trabalhar habilidades socioemocionais essenciais para o processo educativo.</li>
                
                <br/>   
                <p><b>Aprender vai além do conteúdo: é reconhecer a potência de cada ser.</b></p>
                <br />
                <p>A Psicopedagogia não se limita ao desempenho escolar — ela cuida da relação que o indivíduo estabelece com o conhecimento, com a escola e consigo mesmo. Por isso, transformar a aprendizagem é mais do que superar dificuldades: é abrir caminhos para o crescimento pessoal, o equilíbrio emocional e o desenvolvimento integral.</p>
                <br/>
            </div>
        </div>
    </section>
);

export default NeurologistaInfo;